import React, { useEffect, useState } from 'react'
import {
    Box,
    Button,
    Chip,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    IconButton,
} from '@mui/material';
import { getBeatChangeRequests } from '_controllers/officer';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import authAxios from 'setups/axios';
import AccessController from "_shared/AccessController";
import { DashGridL2 } from 'layouts/dash-grid';
import TopBar from '_shared/Top';
import { Toaster } from 'react-hot-toast';
import { PageHeader, SectionCard, EmptyState } from "_shared/ui";

// Map a beat-switch request status to a theme semantic Chip color.
const getStatusColor = (status) => {
    if (status === "Approved") return "success";
    if (status === "Reverted") return "error";
    if (status === "In-Review") return "warning";
    return "default";
};

const Main = () => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [open, setOpen] = useState(false);

    useEffect(async () => {
        // console.log("ft", SAP_ID)
        const plan = await getBeatChangeRequests();
        console.log("first", plan?.pjps)
        setData(plan?.pjps);
        setLoading(true);
    }, [message]);

    const handleApprove = async (action, id, SAP_ID) => {
        console.log("huhu", action, id, SAP_ID);
        const data = {
            action,
            beatId: id,
            SAP_ID
        }
        const response = await authAxios()({
            url: `/api/v1/pjp/beat/switch/action`,
            method: "PUT",
            data
        });
        console.log({ RES2: response?.data });
        setMessage(response?.message);
    };

    const handleRevert = async (action, id, SAP_ID) => {
        const data = {
            action,
            beatId: id,
            SAP_ID
        }
        const response = await authAxios()({
            url: `/api/v1/pjp/beat/switch/action`,
            method: "PUT",
            data
        });
        console.log({ RES: response?.data });
        setMessage(response?.message);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <PageHeader
                title="Switch Beat"
                subtitle="Review and action beat-switch requests"
            />
            {loading ? (
                <SectionCard disablePadding>
                    <TableContainer sx={{ width: "100%", overflowX: "auto" }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">SAP_ID</TableCell>
                                    <TableCell align="center">Status</TableCell>
                                    <TableCell align="center">Activity</TableCell>
                                    <TableCell align="center">Plan Date</TableCell>
                                    <TableCell align="center">Switch Date</TableCell>
                                    <TableCell align="center">Details</TableCell>
                                    <TableCell align="center">Approve</TableCell>
                                    <TableCell align="center">Revert</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data && data?.length > 0
                                    ? data?.map((d) => (
                                        <TableRow key={d._id}>
                                            <TableCell align="left">{d?.SAP_ID}</TableCell>
                                            <TableCell align="center">
                                                <Chip
                                                    size="small"
                                                    label={d?.status}
                                                    color={getStatusColor(d?.status)}
                                                    variant={
                                                        getStatusColor(d?.status) === "default"
                                                            ? "outlined"
                                                            : "filled"
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell align="center">{d?.activity}</TableCell>
                                            <TableCell align="center">
                                                {new Date(d?.planDate).toDateString()}
                                            </TableCell>
                                            <TableCell align="center">
                                                {new Date(d?.switchDate).toDateString()}
                                            </TableCell>
                                            <TableCell align="center">
                                                <Tooltip title="View details">
                                                    <IconButton
                                                        size="small"
                                                        color="primary"
                                                        onClick={() => setOpen(true)}
                                                    >
                                                        <VisibilityIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="center">
                                                {d.status === "In-Review" ? (
                                                    <Button
                                                        onClick={() => handleApprove("approve", d._id, d.SAP_ID)}
                                                        variant='contained'
                                                        color="success"
                                                        size="small"
                                                    >
                                                        Approve
                                                    </Button>
                                                ) : (
                                                    "-"
                                                )}
                                            </TableCell>
                                            <TableCell align="center">
                                                {d.status === "In-Review" ? (
                                                    <Button
                                                        onClick={() => handleRevert("reject", d._id, d.SAP_ID)}
                                                        variant='outlined'
                                                        color="error"
                                                        size="small"
                                                    >
                                                        Revert
                                                    </Button>
                                                ) : (
                                                    "-"
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                    : (
                                        <TableRow>
                                            <TableCell colSpan={8} sx={{ border: 0, p: 0 }}>
                                                <EmptyState
                                                    icon={SwapHorizOutlinedIcon}
                                                    title="No switch requests available"
                                                    description="Beat-switch requests submitted by field officers will appear here."
                                                />
                                            </TableCell>
                                        </TableRow>
                                    )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </SectionCard>
            ) : (
                <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                    <CircularProgress />
                </Box>
            )}
        </>
    );
};

const SwitchBeat = () => {
    return (
        <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
            <DashGridL2 Top={TopBar} Main={Main} />
            <Toaster />
        </AccessController>
    );
};

export default SwitchBeat;
